import { defineComponent, onMounted, onUnmounted } from 'vue';
import EmbeddedDashboardCode from '@/presentation/components/embedded-dashboard/embedded-dashboard.code';

export default defineComponent({
	setup: () => {
		const code = new EmbeddedDashboardCode();

		onMounted(code.mounted.bind(code));
		onUnmounted(code.unmounted.bind(code));

		return {
			dashboardUrl: code.dashboardUrl,
			tableauJWT: code.tableauJWT,
			dashboardWidth: code.dashboardWidth,
			dashboardHeight: code.dashboardHeight
		};
	}
});
